import { render, staticRenderFns } from "./ProjectConfigTab.vue?vue&type=template&id=a59959d6&"
import script from "./ProjectConfigTab.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports